import { Box, Typography, styled } from "@mui/material";
import { useState } from "react";

const SwitchContainer = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  position: "relative",
  backgroundColor: "#f5f5f5",
  borderRadius: "30px",
  padding: "4px",
  cursor: "pointer",
  width: "200px",
  height: "40px",
  transition: "all 0.3s ease",
}));

const Slider = styled(Box)(({ position }) => ({
  position: "absolute",
  left: position === "left" ? "4px" : "50%",
  width: "50%",
  height: "calc(100% - 8px)",
  backgroundColor: "var(--main-color)",
  borderRadius: "26px",
  transition: "all 0.3s ease",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
}));

const SwitchOption = styled(Typography)(({ active }) => ({
  flex: 1,
  textAlign: "center",
  zIndex: 1,
  padding: "8px",
  color: active ? "#fff" : "#666",
  fontWeight: active ? 600 : 500,
  transition: "all 0.3s ease",
  userSelect: "none",
  "&:hover": {
    color: active ? "#fff" : "var(--main-color)",
  },
}));

export default function InspectionTypeRadio({ value, onChange }) {
  const handleClick = () => {
    onChange({ target: { value: value === "AVI" ? "AI" : "AVI" } });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <SwitchContainer onClick={handleClick}>
        <Slider position={value === "AVI" ? "left" : "right"} />
        <SwitchOption active={value === "AVI"}>AVI</SwitchOption>
        <SwitchOption active={value === "AI"}>AI</SwitchOption>
      </SwitchContainer>
    </Box>
  );
}
